import { Box, styled } from '@mui/material';

export const StyledGradeBookGradesList = styled(Box)({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'flex-end',
});

export const StyledGradeBookGrade = styled(Box)<{ $offset?: number }>(({ $offset = 0 }) => ({
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	width: '35px',
	height: '35px',
	borderRadius: '50%',
	border: '2px solid #FFF',
	fontSize: '16px',
	fontWeight: 600,
	color: '#fff',
	position: 'relative',
	marginLeft: $offset ? -8 : 0,
}));
